import vSelect from "vue-select";
import Decimal from "decimal.js";

import { arClient } from "@/api/ar-client";
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
/* import PaymentType from "@/views/modules/booking/PaymentType.vue"; */
import Cleave from "vue-cleave-component";
import FormItem from "../Form/components/FormItem/FormItem.vue";
import PermissionButton from "../../ultils/Button/PermissionButton.vue";
import WidgetSelect from "../../ultils/Form/components/Select/WidgetSelect.vue";
/* import SelectDebitAccount from "@/views/modules/ultils/SelectDebitAccount"; */
import { commonServices } from "@/api/common-services";
import { AR_UPAD01 } from "@/api/constant";
import { VoucherService } from "@/api/voucher-service";

const PaymentDetailType = {
  Payment: "PAYMENT",
  Refund: "REFUND",
};

const PaymentMethodGroup = {
  AR: "AR",
  BANK: "BANK",
  CASH: "CASH",
  TMT: "TMT",
  CREDIT: "CREDIT",
  EZTICKET: "EZTICKET",
  EZGOLF: "EZGOLF",
  VNPAY: "VNPAY",
  OTHER: "OTHER",
  CARD: "CARD",
  QRCODE: "QRCODE",
  ROOM: "ROOM",
  VIP: "VIP",
};

const paymentBase = {
  Id: null,
  PaymentCode: "",
  PaymentDate: "",
  FiscalPaymentDate: "",
  MemberId: null,
  TotalAmount: 0,
  ReceivedAmount: 0,
  PaymentDetail: [],
};

const formBase = {
  PaymentMethodId: null,
  PaymentDetailType: null,
  Note: "",
  CashierId: null,
  Amount: 0,
  CurrencyCode: "",
  CardNumber: "",
  ClientId: null,
  DebitAccountId: null,
  ExpirationDate: null,
  Bdc: null,
};

export default {
  components: {
    PermissionButton,
    FormItem,
    ValidationObserver,
    WidgetSelect,
    /*  PaymentType,
    SelectDebitAccount, */
    vSelect,
    Cleave,
  },
  name: "PaymentForDistribution",
  props: {
    apiCode: String,
    isUpdate: Boolean,

    isShow: Boolean,
    paymentId: {
      type: String,
    },
    /*  bookingDetailIdDistribution: {
      type: Number,
    }, */
    dataPayment: {
      type: Object,
      nullable: true,
    },
    /*  distributionId: {
      type: Number,
    }, */
  },
  data() {
    return {
      isSubmit: true,
      isViewOnly: false,
      number: {
        numeral: true,
        numeralThousandsGroupStyle: "thousand",
      },
      LS_Currency: [],
      listDebtAccount: [],
      PaymentMethods: [],
      PaymentTypeData: [],
      form: {
        ArPaymentId: 0,
        PaymentMethodId: null,
        PaymentDetailType: null,
        Note: "",
        CashierId: null,
        Amount: 0,
        CurrencyCode: "",
        CardNumber: "",
        DebitAccountId: null,
        ClientId: null,
        ExpirationDate: null,
        Bdc: null,
      },
      fields: [
        {
          key: "type",
          label: "ID",
          thStyle: { width: "80%", display: "none" },
          tdClass: "e-td",
        },
        {
          key: "total",
          label: "ID",
          thStyle: { width: "20%", display: "none" },
          tdClass: "e-td",
        },
      ],
      paymentType: "",
      canShowPaymentType: false,
      paymentDr: { ...paymentBase },
      paymentAmountInputExchange: 0,
      debitAccountSelected: {
        Id: null,
        ClientName: "",
      },
      maskExpirationDate: {
        date: true,
        datePattern: ["m", "y"],
        delimiter: "/",
      },
      maskCreditCard: {
        creditCard: true,
      },
      Cashiers: [],
      paymentTypeOptions: [
        /*  {
          title: this.$t("ar_client_refund"),
          value: "REFUND",
        }, */
        {
          title: this.$t("ar_client_payment"),
          value: "PAYMENT",
        },
      ],
      listPaymentType: [],
      zoneId: [],
      paymentTypeName: null,
      TransactionCode: null,
      listClient: [],
      arId: null,
      isLoading: false,
      PaymentMethodByEvoucherInTransactionCode: null,
      PaymentMethodByVoucherInTransactionCode: null,
      isLoadingCheckVoucher: false,
    };
  },
  created() {
    /*   this.getPaymentConfig(); */
    this.getConfigInfo_RCOM01();
    this.getCurrencyList();
  },
  computed: {
    // paymentTypeOptions() {
    //   return [
    //     { title: this.$t('golf_common_payment'), value: PaymentDetailType.Payment },
    //     { title: this.$t('golf_common_refund'), value: PaymentDetailType.Refund },
    //   ]
    // },

    baseCurrency() {
      const baseCurrency = this.LS_Currency.find((s) => s.IsBase || false);
      return (
        baseCurrency || {
          CurrencyCode: "",
          NoOfDec: 0,
        }
      );
    },
    baseCurrencyCode() {
      return "CurrencyCode" in this.baseCurrency ? this.baseCurrency.CurrencyCode : "";
    },
    currencyCodeSelected() {
      return this.form.CurrencyCode || "";
    },
    currencySelected() {
      const currencySelectedDetail = this.LS_Currency.find(
        (s) => s.Format === this.currencyCodeSelected
      );
      if (typeof currencySelectedDetail !== "undefined") {
        return {
          DivBase: currencySelectedDetail.DivBase || false,
          ExRate: currencySelectedDetail.ExRate || 1,
          NoOfDec: currencySelectedDetail.NoOfDec || 0,
        };
      }
      return {
        CurrencyCode: this.currencyCodeSelected,
        DivBase: false,
        ExRate: 1,
        NoOfDec: 0,
      };
    },
    totalAmountPaymentBaseCurr() {
      if (this.paymentDr) {
        return this.paymentDr.TotalAmount || 0;
      }
      return 0;
    },
    totalAmountPaymentExchange() {
      if (this.currencyCodeSelected === this.baseCurrencyCode) {
        return this.totalAmountPaymentBaseCurr;
      }
      return this.GFn_GetExchangeMoney(this.totalAmountPaymentBaseCurr, this.currencySelected);
    },
    amountRemainPayment() {
      if (this.paymentDr) {
        const receivedAmount = this.paymentDr.ReceivedAmount || 0;
        const balance = this.totalAmountPaymentBaseCurr - receivedAmount;
        return balance >= 0 ? balance : 0;
      }
      return 0;
    },
    amountRemainPaymentExchange() {
      if (this.currencyCodeSelected === this.baseCurrencyCode) {
        return this.amountRemainPayment;
      }
      return this.GFn_GetExchangeMoney(this.amountRemainPayment, this.currencySelected);
    },
    isPaymentDiffBase() {
      return this.currencyCodeSelected !== this.baseCurrencyCode;
    },
    showMoneyExchange() {
      return this.isPaymentDiffBase;
    },
    // Format Display
    amountRemainPaymentDisplay() {
      return `${this.formatPrice(this.amountRemainPayment)} ${this.baseCurrencyCode}`;
    },
    totalAmountPaymentBaseCurrDisplay() {
      return `${this.formatPrice(this.totalAmountPaymentBaseCurr)} ${this.baseCurrencyCode}`;
    },
    totalAmountPaymentExchangeDisplay() {
      return `${this.formatPrice(this.totalAmountPaymentExchange)} ${this.currencyCodeSelected}`;
    },
    totalAmountPaymentInputExchangeDisplay() {
      return `${this.formatPrice(this.paymentAmountInputExchange)} ${this.baseCurrencyCode}`;
    },
    showFormInputPaymentMethod() {
      return {
        AR: this.paymentType === PaymentMethodGroup.AR,
        VNPAY: this.paymentType === PaymentMethodGroup.VNPAY,

        BANK: this.paymentType === PaymentMethodGroup.BANK,
        CASH: this.paymentType === PaymentMethodGroup.CASH,
        TMT: this.paymentType === PaymentMethodGroup.TMT,
        CREDIT: this.paymentType === PaymentMethodGroup.CREDIT,
        EZTICKET: this.paymentType === PaymentMethodGroup.EZTICKET,
        EZGOLF: this.paymentType === PaymentMethodGroup.EZGOLF,
        OTHER: this.paymentType === PaymentMethodGroup.OTHER,
        CARD: this.paymentType === PaymentMethodGroup.CARD,
        QRCODE: this.paymentType === PaymentMethodGroup.QRCODE,
        ROOM: this.paymentType === PaymentMethodGroup.ROOM,
        VIP: this.paymentType === PaymentMethodGroup.VIP,
      };
    },
  },
  methods: {
    async getCurrencyList() {
      const res = await arClient.api_AR_RCR01();
      if (res.Status === "200") {
        this.LS_Currency = res.Data.ListCurrency;
      }
    },

    async getConfigInfo_RCOM01() {
      /* const response = await arClient.api_AR_RCL01();
      if (response.Status === "200") {
        return */ this.call_api_RMT01();
      /* } */
    },
    async call_api_RMT01() {
      await arClient
        .api_AR_RMT01({
          ZoneId: ["24"],
        })
        .then(async (response) => {
          if (response.Status === "200") {
            this.listPaymentType = response?.Data?.ListPaymentMethod;

            /*   this.paymentTypeOptions = response?.Data?.ListPaymentMethod.map((x) => ({
              title: x.Name,
              value: x.Code,
            })); */
          }
        });
    },
    async openForm() {
      this.isLoading = true;
      

      this.form.CurrencyCode = this.baseCurrencyCode;
      if (this.paymentId) {
        this.form.ArPaymentId = this.paymentId;
      }

      if (this.dataPayment) {
        this.isViewOnly = true;
        const { PaymentMethodId } = this.dataPayment;

        this.form = { ...this.form, ...this.dataPayment };

        /*   this.handleChoicePayment(
          foundPaymentMethod,
          foundPaymentMethod.PaymentMethods.find((pm) => pm.Id === PaymentMethodId)
        ); */
      } else {
        /*   this.handleChoicePayment(
          this.listPaymentType.find((t) => t.ParentKeyword === "TMT"),
          this.listPaymentType.find((t) => t.ParentKeyword === "TMT").PaymentMethods[0]
        ); */

        this.form.CurrencyCode = this.LS_Currency.find((c) => c.Format === "VND").Id;
        this.form.PaymentDetailType = this.paymentTypeOptions[0]?.value;

        this.isViewOnly = false;
      }
      this.isLoading = false;
    },
    resetFormData() {
      /*     this.paymentType = "";
      this.paymentTypeName = null; */
      this.$emit("update:isUpdatingPayment", false);
      if (this.dataPayment) this.isViewOnly = true;

      this.form = { ...formBase };
      this.paymentDr = { ...paymentBase };
      this.paymentAmountExchange = 0;
      this.PaymentTypeData = [];
    },
    onSelectPaymentType(ev) {
      if (ev.value === PaymentDetailType.Payment) {
        if (this.isPaymentDiffBase) {
          if (this.form.Amount > this.amountRemainPaymentExchange) {
            if (this.form.PaymentDetailType === PaymentDetailType.Payment) {
              this.form.Amount = this.amountRemainPaymentExchange;
            }
          }
          this.paymentAmountInputExchange = this.GFn_GetBaseMoneyFromExchange(
            this.form.Amount,
            this.currencySelected
          );
        } else if (
          this.form.Amount > this.amountRemainPayment &&
          this.form.PaymentDetailType === PaymentDetailType.Payment
        ) {
          this.form.Amount = this.amountRemainPayment;
        }
      }
    },
    onSelectCurrency(ev) {
      this.paymentAmountInputExchange = this.amountRemainPayment;
      this.form.Amount = this.amountRemainPaymentExchange;
    },
    onChangeAmount(ev) {
      if (ev < 0) {
        this.form.Amount = 0;
      }
      if (this.isPaymentDiffBase) {
        if (ev > this.amountRemainPaymentExchange) {
          if (this.form.PaymentDetailType === PaymentDetailType.Payment) {
            this.form.Amount = this.amountRemainPaymentExchange;
          }
        }
        this.paymentAmountInputExchange = this.GFn_GetBaseMoneyFromExchange(
          this.form.Amount,
          this.currencySelected
        );
      } else if (
        ev > this.amountRemainPayment &&
        this.form.PaymentDetailType === PaymentDetailType.Payment
      ) {
        this.form.Amount = this.amountRemainPayment;
      }
    },
    close() {
      this.$emit("closePopup", true);
    },
    handleEvent() {},
    hideModal() {
      this.$bvModal.hide("modal-payment-for-distribution");
    },

    getPaymentMethodDefault(paymentMethods) {
      let paymentMethodDefault = null;
      paymentMethods.forEach((s) => {
        const paymentMethodList = s.PaymentMethod || [];
        paymentMethodList.forEach((s1) => {
          if (s1.Code === PaymentMethodGroup.CASH) {
            paymentMethodDefault = {
              Id: s1.Id,
              Code: s1.Code,
            };
          }
        });
      });
      return paymentMethodDefault;
    },
    calTotalAmount() {
      const totalAmount = this.paymentDr.TotalAmount || 0;
      const receivedAmount = this.paymentDr.ReceivedAmount || 0;
      const balance = totalAmount - receivedAmount;
      const total = balance >= 0 ? balance : 0;
      if (this.paymentDr) {
        return `${this.formatPrice(total)} ${this.baseCurrencyCode}`;
      }
      return `0 ${this.baseCurrencyCode}`;
    },
    async createPaymentDetail_IPM04() {
      const amount = parseFloat(this.form.Amount || "0");
      const paymentData = {
        AccountHolder: this.form.AccountHolder,
        TransactionCode: this.form.TransactionCode,
        PaymentDetailType: this.form.PaymentDetailType,
        Id: this.form.Id,
        ArPaymentId: this.paymentId,
        PaymentGatewayCode: "",
        Qrcode: "",
        PaymentMethodId: this.form.PaymentMethodId,
        FiscalPaymentDetailDate: new Date(),
        Amount: amount,
        Note: this.form.Note,
        CurrencyCode: this.form.CurrencyCode,
        CardNumber: this.form.CardNumber,

        CashierId: this.form.CashierId,
        ExpirationDate: this.createFullDataExpirationDate(this.form.ExpirationDate),
      };

      const dataPost = {
        PaymentDetail: {
          ...paymentData,
        },
      };

      if (amount < 0 || amount === 0) {
        this.showToast("error", this.$t("golf_common_please_enter_money"));
        return;
      }
      if (!paymentData.CurrencyCode) {
        this.showToast("error", this.$t("golf_common_please_select_a_currency"));
        return;
      }

      if (!paymentData.CashierId) {
        this.showToast("error", this.$t("ar_client_please_select_cashier"));
        return;
      }

      if (
        (this.paymentType === PaymentMethodGroup.VNPAY ||
          this.paymentType === PaymentMethodGroup.BANK) &&
        !this.form.TransactionCode
      ) {
        this.showToast("error", this.$t("ar_client_please_select_transaction_code"));
        return;
      }

      if (!this.paymentType || this.form.PaymentMethodId === null) {
        this.showToast("error", this.$t("golf_common_please_select_payment_type"));
        return;
      }
      if (this.paymentType === PaymentMethodGroup.AR) {
        if (!this.form.DebitAccountId) {
          this.showToast("error", this.$t("golf_common_please_choose_debit_account"));
          return;
        }
      }
      if (this.paymentType === PaymentMethodGroup.CARD && !this.form.CardNumber) {
        if (!this.form.DebitAccountId) {
          this.showToast("error", this.$t("golf_common_please_enter_card_number"));
          return;
        }
      }
      if (this.paymentType === PaymentMethodGroup.CREDIT) {
        if (!this.form.AccountHolder) {
          this.showToast("error", this.$t("ar_client_please_select_card_owner"));
          return;
        }
        if (!this.form.CardNumber) {
          this.showToast("error", this.$t("golf_common_please_enter_card_number"));
          return;
        }
        if (!this.form.ExpirationDate) {
          this.showToast("error", this.$t("golf_common_please_enter_expiration_date"));
          return;
        }
      }

      if (this.bookingDetailIdDistribution) {
        const body = {
          TotalAmount: 0,
          Code: null,
          CashierCode:
            this.form.CashierCode && this.form.CashierCode.id
              ? `${this.form.CashierCode.id}`
              : null,
          PaymentDetail: [paymentData],
        };
      } else {
        this.isSubmit = false;
        this.$emit(!this.dataPayment ? "accept-data" : "accept-data-edit", paymentData);
        setTimeout(() => {
          this.isSubmit = true;
        }, 2000);
      }
    },
    getMemberPay() {
      if (this.paymentDr) {
        return `Hóa đơn #${this.paymentDr.Id} ${this.paymentDr.FullName}`;
      }
      return "";
    },

    openModalDeletePaymentDetail(id) {
      this.$emit("event", { type: "open_modal_delete_payment_detail", paymentDetailId: id });
    },
    handlePaymentType(type) {
      const isShow = type === "show";
      if (this.isViewOnly) return;
      this.canShowPaymentType = isShow;
    },
    handleChoicePayment(payment) {
      this.paymentType = payment.ParentKeyword;

      this.canShowPaymentType = false;
      if (
        this.paymentType !== PaymentMethodGroup.CREDIT &&
        this.paymentType !== PaymentMethodGroup.CARD
      ) {
        this.form.CardNumber = "";
      }
    },
    getPaymentMethodNameById(id) {
      let name = id;
      this.PaymentMethods.forEach((x) => {
        x.PaymentMethod.forEach((y) => {
          if (y.Id === id) {
            name = y.Name;
          }
        });
      });
      return name;
    },
    openSelectARAccount() {
      this.$root.$emit("bv::show::modal", "modal-select-ar");
    },
   
    selectArAccount(arAccountData) {
      Object.keys(this.debitAccountSelected).forEach((arKey) => {
        if (arKey in arAccountData) {
          this.debitAccountSelected[arKey] = arAccountData[arKey];
        }
      });
      this.form.DebitAccountId = this.debitAccountSelected.Id;
      this.form.ClientId = this.debitAccountSelected.Id;
    },
    createFullDataExpirationDate(shortExpirationDate) {
      if (shortExpirationDate) {
        const [month, yearOld] = shortExpirationDate.split("/");
        const year = this.dayjs(`${month}/01/${yearOld}`).format("YYYY");
        return new Date(year, month, 0, 23, 59, 59);
      }
      return null;
    },
    GFn_GetExchangeMoney(baseMoney, { DivBase, ExRate, NoOfDec }) {
      const baseMoneyToDecimal = new Decimal(baseMoney || 0);
      let exchangeMoney = 0;
      const noOfDec = NoOfDec || 0;
      const exRate = ExRate || 1;
      if (DivBase || false) {
        exchangeMoney = Decimal.div(baseMoneyToDecimal, exRate).toFixed(noOfDec);
      } else {
        exchangeMoney = Decimal.mul(baseMoneyToDecimal, exRate).toFixed(noOfDec);
      }
      return new Decimal(exchangeMoney).mul(1).toNumber();
    },
    GFn_GetBaseMoneyFromExchange(exchangeMoney, { DivBase, ExRate }) {
      const exchangeMoneyToDecimal = new Decimal(exchangeMoney || 0);
      let baseMoney = 0;
      const noOfDec = this.baseCurrency.NoOfDec || 0;
      const exRate = ExRate || 1;
      if (DivBase || false) {
        baseMoney = Decimal.mul(exchangeMoneyToDecimal, exRate).toFixed(noOfDec);
      } else {
        baseMoney = Decimal.div(exchangeMoneyToDecimal, exRate).toFixed(noOfDec);
      }
      return new Decimal(baseMoney).mul(1).toNumber();
    },
  },
  setup() {
    return { AR_UPAD01 };
  },
  watch: {
    form: {
      handler: function (value) {},
      deep: true,
    },
  },
};
